import { combineReducers } from "redux";
import auth from "./auth.reducer";
import message from "./message.reducer";
import qrs from "./qr.reducer";
import user from "./user.reducer";
import vCard from "./vCard.reducer";
import membership from "./membership.reducer";

export default combineReducers({
  auth,
  message,
  qrs,
  user, //superadmin actions
  vCard,
  membership,
});
